/**
 * Entry point del bundle.
 * Autoregistra <deadbug-editor> al importarse, y reexporta la API pública.
 */

import { registerDeadBugEditor } from './element/deadbug-editor.js';

registerDeadBugEditor();

export { DeadBugEditorElement, registerDeadBugEditor } from './element/deadbug-editor.js';
export { mountEditor, type EditorHandle, type MountOptions } from './element/mount.js';

// Reexports del modelo para consumidores que quieran manipularlo desde fuera.
export type { Project, ProjectMetadata, CanvasSettings } from './core/model/project.js';
export { createEmptyProject, PROJECT_FORMAT_VERSION } from './core/model/project.js';
export type { ComponentInstance } from './core/model/component.js';
export type { PinState, BendState, PinRef, PinAnchor } from './core/model/pin.js';
export type { SolderJoint } from './core/model/solder-joint.js';
export type {
  ComponentDef,
  ComponentCategory,
  BodyDef,
  BodyShape,
  PinDef,
  AppearanceDef,
  ElectricalMetadata,
} from './core/library/component-def.js';
